import { render, staticRenderFns } from "./ReportLaneClosureRequestBlockRestrictionListing.vue?vue&type=template&id=39887ad9&"
import script from "./ReportLaneClosureRequestBlockRestrictionListing.vue?vue&type=script&lang=js&"
export * from "./ReportLaneClosureRequestBlockRestrictionListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports